import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import LabeledSelectBox from 'components/consumer/LabeledSelectBox';
const PDPUpholsterySortBy = t0 => {
  const $ = _c(6);
  const {
    selectedOption,
    setSelectedOption
  } = t0;
  let t1;
  if ($[0] !== setSelectedOption) {
    t1 = event => {
      setSelectedOption(event?.target?.value);
    };
    $[0] = setSelectedOption;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [{
      value: "family",
      label: "Family"
    }, {
      value: "popularity",
      label: "Popularity"
    }, {
      value: "tier",
      label: "Tier"
    }];
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== selectedOption || $[4] !== t1) {
    t3 = <LabeledSelectBox label="Sort by" onChange={t1} options={t2} showSingleLineLabelOverlay={true} prefixOptionsWithLabel={true} showBlankOption={false} size="sm" value={selectedOption} />;
    $[3] = selectedOption;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
PDPUpholsterySortBy.propTypes = {
  selectedOption: PropTypes.string,
  setSelectedOption: PropTypes.func
};
export default PDPUpholsterySortBy;